import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { allRatingAverage, getReviews } from "../../../api/reviews";

export const fetchReviewList = createAsyncThunk(
  "/review-list",
  async (payload) => {
    const res = await getReviews(payload);
    return res;
  }
);
export const fetchTotalReviews = createAsyncThunk(
  "/total-reviews",
  async (id) => {
    const res = await allRatingAverage(id);
    return res;
  }
);
const reviewSlice = createSlice({
  name: "review",
  initialState: {},
  reducers: {},
  isLoading: false,
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReviewList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.res = action.payload;
      })
      .addCase(fetchReviewList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTotalReviews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTotalReviews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.totalReviews = action.payload;
      })
      .addCase(fetchTotalReviews.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});
export { reviewSlice };
